
import { PermissionKey, PlanScope, GrantType } from '@/common/permission';

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      allPermissionOptions: [],
      PermissionKey: PermissionKey
    };
  },

  methods: {
    getPermissionsOptions: function getPermissionsOptions() {
      var _this = this;

      var data = [{
        label: '可玩',
        prop: 'playable',
        planScope: PlanScope.Playable,
        children: [{ value: PermissionKey.gm, label: '可玩换肤编辑' }, { value: PermissionKey.ps, label: '可玩自由编辑' }]
      }, {
        label: '视频',
        prop: 'video',
        planScope: PlanScope.Video,
        children: [{
          value: PermissionKey.ve + ',' + PermissionKey.veBatch,
          label: '视频普通&批量制作'
        }, { value: PermissionKey.vrec, label: '录屏工具' }, { value: PermissionKey.aigc, label: 'AI视频' }, { value: PermissionKey.veTpl, label: '视频模版' }]
      }, {
        label: '数据分析',
        prop: 'analysis',
        planScope: PlanScope.Playable,
        children: [{ value: PermissionKey.insights, label: '创意洞察' }]
      }, {
        label: 'AI',
        prop: 'ai',
        planScope: [PlanScope.Playable, PlanScope.Video],
        children: [{ value: PermissionKey.ai, label: 'AI服务' }]
      }];
      this.allPermissionOptions = this.formValue.plan_scope === PlanScope.Playable_Video ? data : data.filter(function (item) {
        return Array.isArray(item.planScope) && item.planScope.includes(_this.formValue.plan_scope) || item.planScope === _this.formValue.plan_scope;
      });
    },
    checkDisabled: function checkDisabled() {
      return this.action === 'update' || this.formValue.grant_type !== GrantType.Normal;
    }
  },
  watch: {
    'formValue.plan_scope': function formValuePlan_scope() {
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.checkPermissions = [PermissionKey.ai];
      this.getPermissionsOptions();
    }
  },

  created: function created() {
    this.getPermissionsOptions();
  }
};